import { useOrganizationPresenceUsers } from "./usePresenceUsers";
import { ViewerAvatars } from "./ViewerAvatars";

interface OrganizationViewersProps {
    userIds: number[];
}

/** Viewers announced on the organization are staff, so they resolve against its members. */
export const OrganizationViewers = ({ userIds }: OrganizationViewersProps) => (
    <ViewerAvatars users={useOrganizationPresenceUsers(userIds)} />
);
